import EditArtEvent from './EditArtEvent';

export default EditArtEvent;
